export default __webpack_public_path__ + "static/media/edit.783cf9f5.svg";